import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { FormVehicleKeys } from './types'

interface Schema {
    id: FormVehicleKeys
}

interface FormVehicleInterface {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    layout: LayoutProps
}

export const FormVehicleValue = (): FormVehicleInterface[] => {
    return [
        {
            input: { id: 'chassi', label: 'Chassi', onKeyUp: () => ({}) },
            layout: { type: 'col', layout: { base: 12, md: 5 } }
        },
        {
            input: { id: 'renavam', label: 'Renavam', maxLength: 11 },
            layout: { type: 'col', layout: { base: 12, md: 5 } }
        },
        {
            select: { id: 'uf', label: 'UF placa', optionsType: 'uf' },
            layout: { type: 'col', layout: { base: 12, md: 2 } }
        },
        {
            input: {
                id: 'placa',
                label: 'Placa',
                placeholder: '-',
                maskReplace: 'placa'
            },
            layout: { type: 'col', layout: { base: 12, md: 3 } }
        },
        {
            input: {
                id: 'anoFabricacao',
                label: 'Ano fabricação',
                type: 'number',
                inputMode: 'numeric',
                placeholder: '0000'
            },
            layout: { type: 'col', layout: { base: 12, md: 2 } }
        },
        {
            input: {
                id: 'anoModelo',
                label: 'Ano modelo',
                type: 'number',
                inputMode: 'numeric',
                placeholder: '0000'
            },
            layout: { type: 'col', layout: { base: 12, md: 2 } }
        },
        {
            select: {
                id: 'identificacaoRemarcacao',
                label: 'Remarcado?',
                options: [
                    { text: 'SIM', value: 1 },
                    { text: 'NAO', value: 0 }
                ]
            },
            layout: { type: 'col', layout: { base: 12, md: 3 } }
        },
        {
            select: { id: 'ufGravame', label: 'UF gravame', optionsType: 'uf' },
            layout: { type: 'col', layout: { base: 12, md: 2 } }
        },
        {
            input: { id: 'numeroGravame', label: 'Nº do Gravame/Restrição', inputMode: 'numeric' },
            layout: { type: 'col', layout: { base: 12, md: 4 } }
        },
        {
            input: { id: 'marca', label: 'Marca/Modelo', type: 'text' },
            layout: { type: 'col', layout: { base: 12, md: 3 } }
        },
        {
            input: { id: 'cor', label: 'Cor', type: 'text' },
            layout: { type: 'col', layout: { base: 12, md: 3 } }
        },
        {
            select: {
                id: 'especie',
                label: 'Espécie do veículo',
                optionsType: 'especieVeiculo',
                required: true
            },
            layout: { type: 'col', layout: { base: 12, md: 3 } }
        }
    ]
}
